import * as React from 'react';
import classnames from 'classnames';

import styles from './navigator_header.module.scss';

interface Props {
  children?: React.ReactNode;
  className?: string;
}
const NavigatorHeader = (props: Props) => {
  const { className, children } = props;

  const classes = classnames(styles.navigatorHeader, className);

  return (
    <div className={classes}>
      <div className={styles.logo}>
        <img src="https://static.policygenius.com/logos/pg-lg.svg" alt="Policygenius logo" />
      </div>
      <div className={styles.contactBar}>{children}</div>
    </div>
  );
};

export default NavigatorHeader;
